module.exports = __webpack_public_path__ + "img/produman-mob.0de8f0be.jpg";